import { type ReactElement } from 'react';
import { useSegment } from '@repo/poly-hooks/segment';
import { useSearchParams } from 'react-router';
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { Success as SuccessComponent } from '../../components/success/success';

const { frontendUrlsTable } = getUrlsTable(getEnvironmentVariables());

interface SuccessStepProps {
  onFinish?: () => void;
}

export function SuccessStep({ onFinish }: SuccessStepProps): ReactElement {
  const segment = useSegment();
  const [searchParams] = useSearchParams();

  const handleCtaClick = (): void => {
    segment.track('qonto-business-onboarding_finished', {
      sub_product: 'qonto_invoicing',
    });
    onFinish?.();
    window.location.href =
      searchParams.get('return_url') ??
      window.sessionStorage.getItem('qba__return_url') ??
      frontendUrlsTable.appJsURL;
  };

  return <SuccessComponent onCtaClick={handleCtaClick} />;
}
